import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TipoEnvio, TipoEnvioLabels, TipoEnvioIcons, TipoEnvioClasses } from '../enums/tipo-envio.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit {

  @Input() comunicados = [];
  @Input() carregandoComunicado = false;
  @Input() comunicadoSelecionadoId: number = null;
  @Output() selecionado = new EventEmitter<number>();
  @Output() marcarComoLido = new EventEmitter<number>();

  // Expor enums para o template
  TipoEnvio = TipoEnvio;
  TipoEnvioLabels = TipoEnvioLabels;
  TipoEnvioIcons = TipoEnvioIcons;
  TipoEnvioClasses = TipoEnvioClasses;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    if (this.comunicados.length >= 1 ) {
      this.selecionado.emit(this.comunicados[0].id);
    }
  }

  protected exibir(id: number) {
    this.comunicadoSelecionadoId = id;
    this.selecionado.emit(id);
  }

  protected markAsRead(item: any) {
    if (!item.lido) {
      item.lido = true;
      this.marcarComoLido.emit(item.id);
    }
  }

  protected getCor(lido: boolean): any {
    return lido
      ? {'background-color': 'white'}
      : {'background-color': 'bisque'};
  }

  protected formatDate(dateString: string): Date {
    if (!dateString) return new Date();
    
    // Remover o [UTC] do final da string se existir
    const cleanDateString = dateString.replace(/\[UTC\]$/, '');
    
    // Criar a data e ajustar para o timezone local
    const date = new Date(cleanDateString);
    
    // Verificar se a data é válida
    if (isNaN(date.getTime())) {
      return new Date();
    }
    
    return date;
  }

  protected isItemLoading(itemId: number): boolean {
    return this.carregandoComunicado && this.comunicadoSelecionadoId === itemId;
  }

  get formatoDataLista(): string {
    const idioma = this.translate.currentLang || this.translate.defaultLang;
    
    if (idioma === 'gb' || idioma === 'en') {
      // Formato americano: "Oct 9, 2025"
      return "MMM d, y";
    } else {
      // Formato brasileiro: "9 de out. de 2025"
      return "d 'de' MMM 'de' y";
    }
  }

  get formatoHoraLista(): string {
    const idioma = this.translate.currentLang || this.translate.defaultLang;
    
    if (idioma === 'gb' || idioma === 'en') {
      // Formato americano: "4:22 PM"
      return "h:mm a";
    } else {
      // Formato brasileiro: "16:22"
      return "HH:mm";
    }
  }

  get localeAtual(): string {
    const idioma = this.translate.currentLang || this.translate.defaultLang;
    return (idioma === 'gb' || idioma === 'en') ? 'en-US' : 'pt-BR';
  }

}
